import { defineStore } from 'pinia'
import { useStorage } from '~library/composables'
import { Identity, LocalStorage } from '~library/enums'

export const useIdentityStore = defineStore('identity', () => {
  /** 使用者所選擇的身分 */
  const identity = ref<Identity>(Identity.VISITOR)

  const { setStorageData, removeStorageData } = useStorage()

  /** 設定使用者所選擇的身份 */
  const setIdentity = async (value: Identity | null) => {
    identity.value = value ?? Identity.VISITOR

    if (value) {
      setStorageData(LocalStorage.USER_PROFILE_IDENTITY, value)
    } else {
      removeStorageData(LocalStorage.USER_PROFILE_IDENTITY)
    }
  }

  /** 使用者是否登入 */
  const isUserLogin = computed((): boolean => {
    return !!identity.value && identity.value !== Identity.VISITOR
  })

  /** 使用者所選擇的身分是否為差旅人 */
  const isTraveler = computed(
    (): boolean => identity.value === Identity.TRAVELER
  )

  /** 使用者所選擇的身分否為管理者 */
  const isManager = computed((): boolean => {
    return identity.value === Identity.MAIN_MANAGER
  })

  return {
    identity,
    isManager,
    isTraveler,
    isUserLogin,
    setIdentity
  }
})
